/**
 * marketingChannels — 시장 신호 수집 화면의 조건부 수집 채널 카탈로그.
 *
 * 요청 언어·산업군 조건을 가진 추가 채널만 담는다(기본 6채널은 화면에 직접 있다).
 * 서버 레지스트리(saas-ai-agent/src/marketing/channel_registry.py CHANNELS)와 code·조건이 같아야 한다 —
 * 화면은 표시·전송 여부만 정하고, 수집 여부는 서버가 같은 규칙으로 다시 검사한다.
 * code 목록 일치는 서버 테스트(test_channel_registry.py)가 확인한다.
 *
 * 채널 추가: 여기 1건 + 서버 CHANNELS 1건 + lang._MSG 출처명 + 언어팩 라벨(·출처 표기) 키.
 */
import { ALL_INDUSTRY } from "./marketingIndustryKeywords";

export const CONDITIONAL_CHANNELS = [
  {
    code: "maff",                                   // 農林水産省 보도발표 RSS
    labelKey: "mktIntelChannelMaff",
    color: "#2e7d32",
    languages: ["ja"],                              // 빈 배열 = 전 언어
    industries: ["FOOD_BEV"],                       // 빈 배열 = 전 산업군 (ALL_INDUSTRY 선택 시에도 노출)
    attributionKey: "mktIntelMaffAttribution",      // PDL1.0 출처·가공 표기 — 이 채널 기사가 있을 때만 표시
  },
];

// 기본 채널의 언어 제한 — 서버 channel_registry.BUILTIN_LANGUAGES 와 같은 값.
// 네이버는 한국 서비스라 ko 가 아니면 한국어 기사·한국 매체 외국어판만 걸려 잡음이 된다.
export const BUILTIN_CHANNEL_LANGUAGES = { naver: ["ko"] };

/** 기본 채널을 현재 언어에서 쓸 수 있는지. 제한이 없는 채널은 항상 true. */
export function isBuiltinAvailable(code, language) {
  const langs = BUILTIN_CHANNEL_LANGUAGES[code];
  return !langs || langs.includes(language);
}

const isEligible = (ch, language, industry) =>
  (ch.languages.length === 0 || ch.languages.includes(language))
  && (ch.industries.length === 0 || !industry || industry === ALL_INDUSTRY
    || ch.industries.includes(industry));

/** 현재 언어·산업군에서 노출할 조건부 채널. */
export function eligibleChannels(language, industry) {
  return CONDITIONAL_CHANNELS.filter(ch => isEligible(ch, language, industry));
}

export function channelByCode(code) {
  return CONDITIONAL_CHANNELS.find(ch => ch.code === code) || null;
}

/** 신호 목록에 포함된 조건부 채널의 출처 표기 키 — 병합된 신호는 provenance.channel_codes 로 판정한다. */
export function attributionKeys(signals) {
  const codes = new Set();
  (signals || []).forEach(s => {
    if (s?.channel_code) codes.add(s.channel_code);
    (s?.provenance?.channel_codes || []).forEach(c => codes.add(c));
  });
  return CONDITIONAL_CHANNELS
    .filter(ch => ch.attributionKey && codes.has(ch.code))
    .map(ch => ch.attributionKey);
}
